module.exports = __webpack_public_path__ + "static/media/30-8.85f39c8f.mp3";